import { BreadCrumb } from "primereact/breadcrumb";
import React, { useEffect, useRef, useState } from "react";
import { routes } from "../../../routes";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RoleService from "../../../api/RoleService";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Toast } from "primereact/toast";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { Dialog } from "primereact/dialog";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgressSpinner } from "primereact/progressspinner";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import PermissionService from "../../../api/PermissionService";
import { MultiSelect } from "primereact/multiselect";

const Role = () => {
  const items = [{ label: "Roles" }];
  const [refresh, setRefresh] = useState(false);
  const [roles, setRoles] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState("");
  const [name, setName] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [permissionVisible, setPermissionVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const toast = useRef(null);
  const [selectedPermissions, setSelectedPermissions] = useState(null);

  const candidate = {
    icon: "pi pi-lock",
    url: routes.dashboard.role.path,
  };
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const schema = Yup.object({
    name: Yup.string()
      .required("Le nom est obligatoire")
      .min(3, "Trop court")
      .matches(/^([A-Za-z]*)$/gi, "Uniquement des lettres svp !"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          icon="pi pi-plus"
          label="Ajouter un role"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  useEffect(() => {
    setLoading(true);
    RoleService.getAll()
      .then((res) => {
        setRoles(res.data.roles);
        setLoading(false);
      })
      .catch((err) => {});
    PermissionService.getAll()
      .then((res) => {
        setAllPermissions(res.data.permissions);
        setLoading(false);
      })
      .catch((err) => {});
  }, [refresh]);

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ActionBtn
          icon="pi pi-eye"
          severity="primary"
          tooltip="Voir les permissions associées"
          handleClick={() => {
            setPermissions(rowData.permissions);
            setPermissionVisible(true);
          }}
        />
        {/* <ActionBtn
          icon="pi pi-pencil"
          severity="info"
          tooltip="Modifier"
          handleClick={showUpdate}
        /> */}
        <ActionBtn
          icon="pi pi-trash"
          severity="danger"
          tooltip="Supprimer"
          handleClick={() => confirmDelete(rowData.id)}
        />
      </div>
    );
  };

  const addRole = (data) => {
    setLoading(true);
    if (selectedPermissions.length <= 0) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Veuillez choisir au moins une permissions",
        life: 3000,
      });
    } else {
      selectedPermissions.forEach(element => {
        if (data.permissions) {
          
          data.permissions = [...data.permissions, element.name];
        }else{
          data.permissions = [element.name];

        }
      });
       RoleService.create(data)
        .then((res) => {
          setLoading(false);
          setAddVisible(false);
          setRefresh(!refresh);
          reset();
          setSelectedPermissions([])
          toast.current.show({
            severity: "info",
            summary: "Succèss",
            detail: "Role créé avec succès",
            life: 3000,
          });
        })
        .catch((err) => {
          setLoading(false);
          setAddVisible(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Role déjà existant",
            life: 3000,
          });
        }); 
        setLoading(false)
    }
  };

  const deleteRole = () => {
    RoleService.delete(role)
      .then((res) => {
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Role supprimé avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };
  const rejectConfirmation = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulé",
      detail: "Vous aviez annulé la suppression",
      life: 3000,
    });
  };
  const confirmDelete = (id) => {
    setRole(id);
    setConfirm(true);
  };
  return (
    <div className="pl-2 pr-2">
      <Toast ref={toast} />
      <DeleteConfirmation
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={`Voulez-vous réellement supprimé le role ${
          roles.filter((rol) => rol.id === parseInt(role))[0]?.name
        } ?`}
        accept={deleteRole}
        reject={rejectConfirmation}
      />
      <Dialog
        header="Ajouter role"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={handleSubmit(addRole)}>
          <div className="form__item">
            <label htmlFor="name">Nom</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                register={register}
              />
            </div>
            <ErrorMsg>{errors?.name?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="site">Parcours</label>
            <div className="form__item__ic_p">
              <MultiSelect
                value={selectedPermissions}
                /*  onChange={(e) => {
                  setClassroom(e.value);
                }} */
                onChange={(e) => setSelectedPermissions(e.value)}
                options={allPermissions}
                optionLabel="name"
                placeholder="Sectionner une permission"
                className="w-full"
                display="chip"
              />
            </div>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Permissions associées"
        visible={permissionVisible}
        style={{ width: "50vw" }}
        onHide={() => setPermissionVisible(false)}
      >
        <DataTable
          value={permissions}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "100%" }}></Column>
        </DataTable>
      </Dialog>
      <BreadCrumb model={items} home={candidate} />
      <div className="">
        <DataTable
          value={roles}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "50%" }}></Column>
          <Column
            header="Action"
            body={actionTemplate}
            style={{ width: "50%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Role;
